import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Footer, LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import { useConfiguration } from '../../context/configurationContext';
import { useSelector } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import css from './CustomWelcomePage.module.css';

import illustration from '../../assets/program_img1.png';
import { useHistory } from 'react-router-dom';
import WelcomeSection from './Sections/WelcomeSection';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';

const CustomWelcomePage = () => {
  const intl = useIntl();
  const config = useConfiguration();
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  const state = useSelector(state => state);
  const scrollingDisabled = isScrollingDisabled(state);

  const schemaTitle = intl.formatMessage({ id: 'CustomWelcomePage.schemaTitle' });
  const schemaDescription = intl.formatMessage({ id: 'CustomWelcomePage.schemaDescription' });
  const schemaImage = `${config.marketplaceRootURL}${illustration}`;

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      title={schemaTitle}
      description={schemaDescription}
      facebookImages={[{ url: illustration, width: 1200, height: 630 }]}
      twitterImages={[{ url: illustration, width: 600, height: 314 }]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
        description: schemaDescription,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn
        className={css.pageRoot}
        topbar={<TopbarContainer isFullWidthHeader={true} isPostLandingPage />}
        footer={<Footer hideNewsLetter />}
      >
        <div className={css.customWelcomePageMain}>
          <WelcomeSection intl={intl} history={history} routeConfiguration={routeConfiguration} />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default CustomWelcomePage;
